// @generated by TypeGen from LogbookModel/Status/AlertEngineModel.swift - DO NOT EDIT

export enum IAlertLoudness {
  notificationOnly,
  audible,
}
